import React, { useState, ChangeEvent, useEffect } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography, FormControl, MenuItem, InputAdornment, IconButton, Checkbox, FormControlLabel, Autocomplete, CircularProgress } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { LocalizationProvider, DesktopDatePicker, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import KenButton from '../../../../GlobalComponents/KenButton';
import { getEmployeedetailsLocationPicklistValue, getEmployeedetailsPicklistValue, getEmployeementDetails, getJobs, postEmployeementDetails } from '../../../../Utils/apiService';
import { EmployeementDetails } from '../../../../interfaces/Profile';
import dayjs, { Dayjs } from 'dayjs';
import { enqueueSnackbar } from 'notistack';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '40vw', xl: '40vw' },
  p: 2,
};
function sleep(duration: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}

const AddEmployeeDetails = (props: any) => {
  console.log('props', props);
  const { userData, value } = props;
  console.log('userData12', value);

  const classes = useStyles();
  const [formData, setFormData] = useState<EmployeementDetails>({
    title: value?.Title__c ? value?.Title__c : '',
    companyName: value?.Company__r?.Name ? value?.Company__r?.Name : '',
    employmentType: value?.Employment_Type__c ? value?.Employment_Type__c : '',
    location: value?.Location__c ? value?.Location__c : '',
    locationtype: value?.Location_Type__c ? value?.Location_Type__c : '',
    startDate: value?.Start_Date__c ? value?.Start_Date__c : '',
    endDate: value.currentlyworkinghere ? "" : value?.End_Date__c,
    contactId: userData.applicantId,
    fileBlob: value?.Company__r?.Logo_File_URL__c ? value?.Company__r?.Logo_File_URL__c : '',
    fileName: 'test',
    currentlyworkinghere: value?.Currently_working_here__c ? value?.Currently_working_here__c : false,
  });
  console.log('formData', formData);

  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(value?.Start_Date__c ? value?.Start_Date__c : null));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(value?.End_Date__c ? value?.End_Date__c : null));
  const [fileName, setFileName] = useState<string>('');
  const [base64Image, setBase64Image] = useState<string | null>(value?.Company__r?.Logo_File_URL__c ? value?.Company__r?.Logo_File_URL__c : null);

  const handleChangeStartDate = (newDate: Dayjs | null) => {
    setStartDate(newDate);
  };

  const handleChangeEndDate = (newDate: Dayjs | null) => {
    setEndDate(newDate);
  };


  const [locationTypeOptions, setLocationTypeOptions] = useState([]);
  const [employmentTypeOptions, setEmploymentTypeOptions] = useState([]);
  const [locationType, setLocationType] = useState(value?.Location_Type__c ? value?.Location_Type__c : '');
  const [employmentType, setEmploymentType] = useState(value?.Employment_Type__c ? value?.Employment_Type__c : '');

  const handleChangeLocationType = (event: SelectChangeEvent) => {
    setLocationType(event.target.value as string);
    setErrors((prev) => ({ ...prev, locationType: "" }));
  };

  const handleChangeEmploymentType = (event: SelectChangeEvent) => {
    setEmploymentType(event.target.value as string);
    setErrors((prev) => ({ ...prev, employmentType: "" }));
  };


  useEffect(() => {
    // Fetch Location Type options
    getEmployeedetailsLocationPicklistValue().then((res: any) => {

      const options = res?.data?.data?.records.map((item: any) => ({
        label: item.Label,
        value: item.Value,
      }));
      setLocationTypeOptions(options);
    });

    // Fetch Employment Type options
    getEmployeedetailsPicklistValue().then((res: any) => {
      console.log(res?.data?.data?.records, "res?.data?.data?.records");

      const options = res?.data?.data?.records.map((item: any) => ({
        label: item.Label,
        value: item.Value,
      }));
      setEmploymentTypeOptions(options);
    });
  }, []);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const splitData = base64String.split(',');
        setBase64Image(splitData[1]);
        console.log('Base64 Image: ', base64String);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleChangeField = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, type, value, checked } = event.target;

    // Temporary new form data
    const newFormData = {
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    };

    setFormData(newFormData);

    // Clear the error for the specific field being updated
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear error for the specific field
    }));

    // Validate the entire form to ensure other fields are still valid
    validateForm(newFormData);
  };
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly any[]>([]);

  const handleOpen = () => {
    setOpen(true);
    (async () => {
      await sleep(1e3);
      setOptions([...options]);
    })();
  };

  const handleClose = () => {
    setOpen(false);
    setOptions([]);
  };


  useEffect(() => {
    getEmployeementDetails(userData.applicantId)
      .then((res) => {
        setOptions(res?.allLocations.map((city: any) => ({ title: city })));
      })
      .catch((err) => {
        console.error(err);
      });
  }, [open])
  useEffect(() => {
    if (base64Image) {
      setErrors((prevErrors) => ({ ...prevErrors, fileBlob: "" }));
    }
  }, [base64Image]);

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateForm = (formDataToValidate = formData) => {
    let newErrors: { [key: string]: string } = {};

    if (!formDataToValidate.title.trim()) newErrors.title = "Title is required";
    if (!formDataToValidate.companyName.trim()) newErrors.companyName = "Company name is required";
    if (!employmentType) newErrors.employmentType = "Employment type is required";
    if (!locationType) newErrors.locationType = "Location type is required";
    if (!formDataToValidate.location.trim()) newErrors.location = "Location is required";
    if (!base64Image) newErrors.fileBlob = "Company logo is required";
    if (!startDate) newErrors.startDate = "Start date required";
    if (!formDataToValidate.currentlyworkinghere && !endDate) newErrors.endDate = "End date required";
    // if (!endDate) newErrors.endDate = "End date required";
    if (!startDate || !dayjs(startDate).isValid()) {
      newErrors.startDate = "Start date is required";
    }
    if (!formDataToValidate.currentlyworkinghere) {
      if (!endDate || !dayjs(endDate).isValid()) {
        newErrors.endDate = "End date is required";
      }
    }
    // Ensure end date is not before start date
    if (startDate && endDate && dayjs(endDate).isBefore(dayjs(startDate))) {
      newErrors.endDate = "End date cannot be earlier than start date";
    }

    // Add validation for start and end dates
    if (startDate && endDate) {
      if (dayjs(startDate).isSame(dayjs(endDate))) {
        newErrors.startDate = "Start date and end date cannot be the same";
        newErrors.endDate = "Start date and end date cannot be the same";
      } else if (dayjs(endDate).isBefore(dayjs(startDate))) {
        newErrors.endDate = "End date cannot be earlier than start date";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const postEmployeementsDetails = () => {
    if (!validateForm()) {
      enqueueSnackbar({
        message: "Please fill all fields",
        variant: "error",
        autoHideDuration: 1500,
      });
      return;
    }

    const payload: any = {
      ...formData,
      employmentType: employmentType,
      locationtype: locationType,
      startDate,
      endDate,
      fileBlob: base64Image,
      fileName: fileName,
    };
    console.log('payload324', payload);

    postEmployeementDetails(payload)
      .then((res) => {
        if (res?.success) {
          props.setPreferStatus(true);
          enqueueSnackbar({
            message: 'Employeement Details Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          props.handleClose();
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        props.handleClose();
        console.error(err);
      });
  };

  return (
    <div>
      <Box sx={style}>
        <Typography
          sx={{
            textAlign: 'left',
            fontWeight: 500,
            fontSize: '13px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              fontSize: '12px !important',
            },
          }}
        >
          {props.data == 'edit' ? 'Edit Position' : 'Add Position'}
        </Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: '-40px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '60vh',
            },
          }}
          className="scrollbar-cusgray"
        >
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Title
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              name="title"
              value={formData.title}
              onChange={handleChangeField}
              placeholder="Enter title"
              variant="outlined"
              error={!!errors.title}
              helperText={errors.title ? "Please fill mandatory field *" : ""}
              fullWidth
            />
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 0px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Employment Type
            </Typography>
            <FormControl fullWidth sx={{ mt: 1.5 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={employmentType}
                placeholder="Select"
                onChange={handleChangeEmploymentType}
                size="small"
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  height: '36px',
                  fontSize: '12px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    fontSize: '12px',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '12px',
                  },
                }}
                error={!!errors.employmentType}

              >
                {employmentTypeOptions.map((option: any) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              <Typography style={{ color: "#e75547", fontSize: "14px", margin: 3 }}>{errors.employmentType ? "Please fill mandatory field *" : ""}</Typography>
            </FormControl>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Location Type
            </Typography>
            <FormControl fullWidth sx={{ mt: 1.5 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={locationType}
                placeholder="Select"
                onChange={handleChangeLocationType}
                size="small"
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  height: '36px',
                  fontSize: '12px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    fontSize: '12px',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '12px',
                  },
                }}
                error={!!errors.locationType}
              >
                {locationTypeOptions.map((option: any) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              <Typography style={{ color: "#e75547", fontSize: "14px", margin: 3 }}>{errors.locationType ? "Please fill mandatory field *" : ""}</Typography>
            </FormControl>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Start Date
            </Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={['year', 'month']}
                  value={startDate}
                  onChange={handleChangeStartDate}
                  format="MM/YYYY"
                  slotProps={{
                    textField: {
                      placeholder: 'MM/YYYY',
                      size: 'small',
                      fullWidth: true,
                      error: !!errors.startDate,
                      helperText: errors.startDate,
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                          borderRadius: "6px",
                          fontSize: "12px",
                        },
                        "& .MuiOutlinedInput-input": {
                          fontSize: "12px",
                        },
                      },
                    },
                    popper: {
                      placement: 'top-start', // <-- this controls where the popper appears
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
            <Typography sx={{ mt: 4, ml: 0 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="currentlyworkinghere"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: '18px',
                      },
                    }}
                    checked={formData.currentlyworkinghere}
                    onChange={handleChangeField}
                  />
                }
                label={<Typography sx={{ fontSize: '12px' }}>I'm Currently Working Here</Typography>}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Add Company Logo
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              variant="outlined"
              fullWidth
              size="small"
              placeholder="Upload Image"
              value={fileName}
              error={Boolean(errors.fileBlob)}
              helperText={errors.fileBlob ? "Please fill mandatory field *" : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton component="label">
                      <input type="file" hidden accept="image/*" onChange={handleFileChange} />
                      <FileUploadOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Company Name
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChangeField}
              variant="outlined"
              fullWidth
              error={!!errors.companyName}
              helperText={errors.companyName ? "Please fill mandatory field *" : ""}
            />
            <Typography
              sx={{
                fontWeight: 500,
                mt: 4.7,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Location
            </Typography>
            <Autocomplete
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              open={open}
              onOpen={handleOpen}
              onClose={handleClose}
              freeSolo
              isOptionEqualToValue={(option, value) => option.title === value.title}
              getOptionLabel={(option) => typeof option === 'string' ? option : option.title}
              options={options}
              value={formData.location ? { title: formData.location } : null}
              onChange={(_, newValue) => {
                let valueToSet = '';
                if (typeof newValue === 'string') {
                  valueToSet = newValue;
                  if (!options.find(opt => opt.title === newValue)) {
                    setOptions((prev) => [...prev, { title: newValue }]);
                  }
                } else if (newValue) {
                  valueToSet = newValue.title;
                }

                setFormData((prev) => ({
                  ...prev,
                  location: valueToSet,
                }));

                // Clear error and validate
                setErrors((prev) => ({ ...prev, location: '' }));
                validateForm();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Enter your location"
                  name="location"
                  variant="outlined"
                  error={!!errors.location}
                  helperText={errors.location ? "Please fill mandatory field *" : ""}
                  fullWidth
                  onBlur={(event) => {
                    const inputValue = event.target.value.trim();
                    if (inputValue !== '') {
                      if (!options.some(opt => opt.title === inputValue)) {
                        setOptions((prev) => [...prev, { title: inputValue }]);
                      }
                      setFormData((prev) => ({
                        ...prev,
                        location: inputValue,
                      }));
                    } else {
                      setFormData((prev) => ({ ...prev, location: '' }));
                    }

                    setErrors((prev) => ({ ...prev, location: '' }));
                    validateForm();
                  }}
                />
              )}
            />

            <Typography
              sx={{
                fontWeight: 500,
                mt: 5,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              End Date
            </Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={['year', 'month']}
                  value={formData.currentlyworkinghere ? null : endDate}
                  onChange={handleChangeEndDate}
                  format="MM/YYYY"
                  minDate={startDate ? dayjs(startDate) : undefined}
                  disabled={!startDate || formData.currentlyworkinghere}
                  slotProps={{
                    textField: {
                      placeholder: 'MM/YYYY',
                      size: 'small',
                      fullWidth: true,
                      error: !!errors.endDate,
                      helperText: errors.endDate,
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          height: "36px",
                          borderRadius: "6px",
                          fontSize: "12px",
                        },
                        "& .MuiOutlinedInput-input": {
                          fontSize: "12px",
                        },
                      },
                    },
                    popper: {
                      placement: 'top-start',
                    },
                  }}
                />

              </LocalizationProvider>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 2,
              borderRadius: '8px',
              width: 100,
              '&:hover': {
                backgroundColor: 'transparent',
              },
              color: 'black',
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                color: '#373A45',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Cancel
            </Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, boxShadow: 'none', height: '36px' }}
            onClick={() => {
              postEmployeementsDetails();
            }}
            fullWidth
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Save
            </Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddEmployeeDetails;
